type FormRequirementItem = "required" | "optional" | "none";
type FormRequirements = {
  license: FormRequirementItem;
  vehicle: FormRequirementItem;
  region: FormRequirementItem;
};

export const getEmployeeInfo = ({
  professionSettingsList,
  enableParkInfoFromContext,
}: {
  professionSettingsList?: {
    profession_id: string;
    employment_type_list?: {
      employment_type:
        | "selfemployed"
        | "individual_entrepreneur"
        | "park_employee";
      required_fields?: string[];
      optional_fields?: string[];
    }[];
    redirect_link?: string;
    form_requirements: FormRequirements;
  }[];
  enableParkInfoFromContext: boolean;
}) => {
  if (!professionSettingsList) {
    return {
      profession: undefined,
      employmentType: undefined,
      isMultipleProfessions: false,
      isMultipleEmploymentTypes: false,
    };
  }

  const isMultipleProfessions = professionSettingsList.length > 1;
  const profession = !isMultipleProfessions
    ? professionSettingsList[0]
    : undefined;

  const isMultipleEmploymentTypes = isMultipleProfessions
    ? professionSettingsList.some(
        (profession) =>
          profession.employment_type_list &&
          profession.employment_type_list.length > 1,
      )
    : professionSettingsList[0]?.employment_type_list &&
      professionSettingsList[0].employment_type_list.length > 1;
  const employmentType =
    profession &&
    (!enableParkInfoFromContext ||
      (profession.employment_type_list?.length ?? 0) === 1)
      ? profession.employment_type_list?.[0]?.employment_type
      : undefined;

  return {
    profession,
    employmentType,
    isMultipleProfessions,
    isMultipleEmploymentTypes,
  };
};
